import { render } from "./ChecklistIndex.vue?vue&type=template&id=6389cca1"
import script from "./ChecklistIndex.vue?vue&type=script&lang=js"
export * from "./ChecklistIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__